import React from 'react';

export const context = {
    finn: {
        whitelabel: 'finn',
        country: 'NO',
        language: 'NO',
        currency: 'NOK',
        disableCo2: true,
        disableSavedSearch: false,
        disableResultListWidget: false,
        disableVerticals: false,
        disableEasyAdPanel: false,
        disableCmsPanel: false,
        disablePrepackage: false,
        theme: {
            buttonBackgroundColor: '',
            expansionPanelBackgroundColor: '',
            activeIconColor: '#06befb',
            inactiveIconColor: '#767676',
        },
        path: {
            flight: '/reise/flybilletter',
            frontpage: '/reise',
            frontpageNew: '/reise-front',
        },
        apiBaseUrl: 'https://www.finn.no/travel-api',
        // TODO remove this and use config in nextjs instead (after
        cdnBaseUrl: 'https://static.finncdn.no/_c/travel-frontpage-web/',
        hotelBaseUrl: 'https://hotell.finn.no',
        carBaseUrl: 'https://leiebil.finn.no',
        verticalToPath: {
            flight: '',
            hotel: 'hotell',
            carrental: 'leiebil',
            prepackage: 'pakker',
        },
    },
    blocket: {
        whitelabel: 'blocket',
        country: 'SE',
        language: 'SV',
        currency: 'SEK',
        disableCo2: false,
        disableSavedSearch: true,
        disableResultListWidget: true,
        disableVerticals: true,
        disableEasyAdPanel: false,
        disableCmsPanel: false,
        disablePrepackage: true,
        theme: {
            buttonBackgroundColor: '#49B975',
            expansionPanelBackgroundColor: '#f9f7f6',
            activeIconColor: '#4182c3',
            inactiveIconColor: '#9A9999',
        },
        path: {
            flight: '/flyg',
            frontpage: '',
            frontpageNew: '/front',
        },
        apiBaseUrl: 'https://resor.blocket.se/travel-api',
        cdnBaseUrl: 'https://static.finncdn.no/_c/travel-frontpage-web/',
        hotelBaseUrl: 'https://hotell.blocket.se',
        carBaseUrl: 'https://hyrbil.blocket.se',
        verticalToPath: {
            flight: '',
            hotel: 'hotell',
            carrental: 'hyrbil',
        },
    },
};

export default React.createContext(context.finn);
